var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-container",
    { staticClass: "px-0", attrs: { fluid: "" } },
    [
      !!_vm.revisionEvaluador
        ? _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c(
                    "b-overlay",
                    { attrs: { show: _vm.mostrarOverlay } },
                    [
                      _c(
                        "b-row",
                        [
                          _c("b-col", [
                            _c("strong", [
                              _c("span", {
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t(
                                      "apeironGwApp.valoracionIndividualSNP.campos.solucion"
                                    ) + ":"
                                  ),
                                },
                              }),
                            ]),
                            _vm._v(" "),
                            _c("span", {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.revisionEvaluador?.solicitudResumen
                                    ?.nombre ?? ""
                                ),
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("b-col", [
                            _c("strong", [
                              _c("span", {
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t(
                                      "apeironGwApp.valoracionIndividualSNP.campos.comisionEvaluacion"
                                    ) + ":"
                                  ),
                                },
                              }),
                            ]),
                            _vm._v(" "),
                            _c("span", {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.revisionEvaluador?.respuesta?.comision ??
                                    ""
                                ),
                              },
                            }),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c("b-col", [
                            _c("strong", [
                              _c("span", {
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t(
                                      "apeironGwApp.valoracionIndividualSNP.campos.estado"
                                    ) + ":"
                                  ),
                                },
                              }),
                            ]),
                            _vm._v(" "),
                            _c("span", {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.revisionEvaluador?.estado ?? ""
                                ),
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("b-col", [
                            _c("strong", [
                              _c("span", {
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t(
                                      "apeironGwApp.valoracionIndividualSNP.campos.tipoEvaluacion"
                                    ) + ":"
                                  ),
                                },
                              }),
                            ]),
                            _vm._v(" "),
                            _c("span", {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.evaluacionDescripcion ?? ""
                                ),
                              },
                            }),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c("b-col", [
                            _c("hr", { staticClass: "linea-horizontal-roja" }),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            [
                              _c("cuestionario-snp", {
                                attrs: {
                                  preguntas: _vm.preguntas,
                                  esMoloLectura:
                                    _vm.estadoInsaculacion != "APROBADA" &&
                                    _vm.revisionEvaluador.estado != "ASIGNADA",
                                  cuestionarioInicial: _vm.cuestionarioInicial,
                                  mostrarRecomendacion: true,
                                },
                                on: { change: _vm.manejaFormularioCambia },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "mt-3" },
                        [
                          _c(
                            "b-col",
                            { staticClass: "text-right" },
                            [
                              _vm.estadoInsaculacion == "APROBADA" &&
                              _vm.revisionEvaluador.estado == "ASIGNADA"
                                ? _c(
                                    "b-button",
                                    {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip.hover",
                                          value: _vm.$t(
                                            "apeironGwApp.valoracionIndividualSNP.acciones.guardarTooltip"
                                          ),
                                          expression:
                                            "$t('apeironGwApp.valoracionIndividualSNP.acciones.guardarTooltip')",
                                          modifiers: { hover: true },
                                        },
                                      ],
                                      staticClass: "btn-primary",
                                      on: {
                                        click: function ($event) {
                                          return _vm.mostrarModalGuardar()
                                        },
                                      },
                                    },
                                    [
                                      _c("b-icon", {
                                        attrs: {
                                          icon: _vm.guardandoEvaluacion
                                            ? "asterisk"
                                            : "check-square",
                                          animation: _vm.guardandoEvaluacion
                                            ? "spin-pulse"
                                            : "",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("span", {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "apeironGwApp.valoracionIndividualSNP.acciones.guardar"
                                            )
                                          ),
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.estadoInsaculacion == "APROBADA" &&
                              _vm.revisionEvaluador.estado == "ASIGNADA"
                                ? _c(
                                    "b-button",
                                    {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip.hover",
                                          value: _vm.$t(
                                            "apeironGwApp.valoracionIndividualSNP.acciones.finalizarTooltip"
                                          ),
                                          expression:
                                            "$t('apeironGwApp.valoracionIndividualSNP.acciones.finalizarTooltip')",
                                          modifiers: { hover: true },
                                        },
                                      ],
                                      staticClass: "btn-primary",
                                      attrs: { disabled: !_vm.puedeFinalizar },
                                      on: {
                                        click: function ($event) {
                                          return _vm.mostrarModalFinalizar()
                                        },
                                      },
                                    },
                                    [
                                      _c("b-icon", {
                                        attrs: {
                                          icon: _vm.finalizandoEvaluacion
                                            ? "asterisk"
                                            : "clipboard-check",
                                          animation: _vm.finalizandoEvaluacion
                                            ? "spin-pulse"
                                            : "",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("span", {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "apeironGwApp.valoracionIndividualSNP.acciones.finalizar"
                                            )
                                          ),
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.estadoInsaculacion == "APROBADA" &&
                              _vm.revisionEvaluador.estado == "ASIGNADA"
                                ? _c(
                                    "b-button",
                                    {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip.hover",
                                          value: _vm.$t(
                                            "apeironGwApp.valoracionIndividualSNP.acciones.cancelarTooltip"
                                          ),
                                          expression:
                                            "$t('apeironGwApp.valoracionIndividualSNP.acciones.cancelarTooltip')",
                                          modifiers: { hover: true },
                                        },
                                      ],
                                      staticClass: "btn-primary",
                                      attrs: {
                                        disabled:
                                          !_vm.cuestionario
                                            .comentariosGenerales,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.mostrarModalCancelar()
                                        },
                                      },
                                    },
                                    [
                                      _c("b-icon", {
                                        attrs: {
                                          icon: _vm.cancelandoEvaluacion
                                            ? "asterisk"
                                            : "clipboard-x",
                                          animation: _vm.cancelandoEvaluacion
                                            ? "spin-pulse"
                                            : "",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("span", {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "apeironGwApp.valoracionIndividualSNP.acciones.cancelar"
                                            )
                                          ),
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c(
                "b-modal",
                {
                  attrs: { id: "modal-guardar", size: "md" },
                  scopedSlots: _vm._u([
                    {
                      key: "modal-title",
                      fn: function () {
                        return [
                          _c("span", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t(
                                  "apeironGwApp.valoracionIndividualSNP.modal.tituloModalGuardar"
                                )
                              ),
                            },
                          }),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "modal-footer",
                      fn: function () {
                        return [
                          _c(
                            "b-button",
                            {
                              attrs: { variant: "secondary" },
                              on: {
                                click: function ($event) {
                                  _vm.verModalGuardar = false
                                },
                              },
                            },
                            [
                              _c("span", {
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t(
                                      "apeironGwApp.valoracionIndividualSNP.acciones.cerrar"
                                    )
                                  ),
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              attrs: { variant: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.guardarEvaluacion()
                                },
                              },
                            },
                            [
                              _c("b-icon", { attrs: { icon: "save" } }),
                              _vm._v(" "),
                              _c("span", {
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t(
                                      "apeironGwApp.valoracionIndividualSNP.acciones.guardar"
                                    )
                                  ),
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                  model: {
                    value: _vm.verModalGuardar,
                    callback: function ($$v) {
                      _vm.verModalGuardar = $$v
                    },
                    expression: "verModalGuardar",
                  },
                },
                [
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c("b-col", [
                        _c("h5", [
                          _c("span", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t(
                                  "apeironGwApp.valoracionIndividualSNP.modal.detalleModalGuardar"
                                )
                              ),
                            },
                          }),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-modal",
                {
                  attrs: { id: "modal-finalizar", size: "md" },
                  scopedSlots: _vm._u([
                    {
                      key: "modal-title",
                      fn: function () {
                        return [
                          _c("span", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t(
                                  "apeironGwApp.valoracionIndividualSNP.modal.tituloModalFinalizar"
                                )
                              ),
                            },
                          }),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "modal-footer",
                      fn: function () {
                        return [
                          _c(
                            "b-button",
                            {
                              attrs: { variant: "secondary" },
                              on: {
                                click: function ($event) {
                                  _vm.verModalFinalizar = false
                                },
                              },
                            },
                            [
                              _c("span", {
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t(
                                      "apeironGwApp.valoracionIndividualSNP.acciones.cerrar"
                                    )
                                  ),
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              attrs: { variant: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.finalizarEvaluacion()
                                },
                              },
                            },
                            [
                              _c("b-icon", { attrs: { icon: "save" } }),
                              _vm._v(" "),
                              _c("span", {
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t(
                                      "apeironGwApp.valoracionIndividualSNP.acciones.finalizar"
                                    )
                                  ),
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                  model: {
                    value: _vm.verModalFinalizar,
                    callback: function ($$v) {
                      _vm.verModalFinalizar = $$v
                    },
                    expression: "verModalFinalizar",
                  },
                },
                [
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c("b-col", [
                        _c("h5", [
                          _c("span", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t(
                                  "apeironGwApp.valoracionIndividualSNP.modal.detalleModalFinalizar"
                                )
                              ),
                            },
                          }),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-modal",
                {
                  attrs: { id: "modal-cancelar", size: "md" },
                  scopedSlots: _vm._u([
                    {
                      key: "modal-title",
                      fn: function () {
                        return [
                          _c("span", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t(
                                  "apeironGwApp.valoracionIndividualSNP.modal.tituloModalCancelar"
                                )
                              ),
                            },
                          }),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "modal-footer",
                      fn: function () {
                        return [
                          _c(
                            "b-button",
                            {
                              attrs: { variant: "secondary" },
                              on: {
                                click: function ($event) {
                                  _vm.verModalCancelar = false
                                },
                              },
                            },
                            [
                              _c("span", {
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t(
                                      "apeironGwApp.valoracionIndividualSNP.acciones.cerrar"
                                    )
                                  ),
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              attrs: { variant: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.cancelarEvaluacion()
                                },
                              },
                            },
                            [
                              _c("b-icon", { attrs: { icon: "save" } }),
                              _vm._v(" "),
                              _c("span", {
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t(
                                      "apeironGwApp.valoracionIndividualSNP.acciones.cancelar"
                                    )
                                  ),
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                  model: {
                    value: _vm.verModalCancelar,
                    callback: function ($$v) {
                      _vm.verModalCancelar = $$v
                    },
                    expression: "verModalCancelar",
                  },
                },
                [
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c("b-col", [
                        _c("h5", [
                          _c("span", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t(
                                  "apeironGwApp.valoracionIndividualSNP.modal.detalleModalCancelar"
                                )
                              ),
                            },
                          }),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }